module.exports = __webpack_public_path__ + "img/in_office_greeen.7c6f14dd.svg";